import { checkExpToken } from "helpers/auth";
import { getPaymentPolicyDocuments, removeRatingCodesFromRisks } from "helpers/policy";
// import { axios } from "helpers/axios";
import { setActiveRisk, setGlobalNarratives } from "globals/auth";
import { handleCreateBuySummaryPDF } from "api/external/pdf";
import branchInfo from "helpers/config";
import { collisionSpec } from "components/ClaimsProcess/AccidentType/constants";
import { toast } from "react-toastify";
import logger from "utils/logger";
import { updateExtensions, updateBatchActions } from "../../misc/PolicyManager/helpers";

function appendGlobalNamesToDrivers(policy) {
	// Create a shallow copy of the policy to avoid modifying the original
	const policyCopy = { ...policy };

	// Create a map of global_name_id to global_name for quick lookup
	const globalNamesMap = new Map();

	if (policy.global_names && Array.isArray(policy.global_names)) {
		policy.global_names.forEach(globalName => {
			if (globalName.global_name_id) {
				globalNamesMap.set(globalName.global_name_id, globalName);
			}
		});
	}

	// Process risks - create a new risks array with cloned risk objects
	if (policy.risks && Array.isArray(policy.risks)) {
		policyCopy.risks = policy.risks.map(riskDetail => {
			// Create a shallow copy of the risk detail
			const riskCopy = { ...riskDetail };

			if (riskDetail.drivers && Array.isArray(riskDetail.drivers)) {
				// Create a new drivers array with updated driver objects
				riskCopy.drivers = riskDetail.drivers.map(driver => {
					if (driver.global_name_id && globalNamesMap.has(driver.global_name_id)) {
						const matchingGlobalName = globalNamesMap.get(driver.global_name_id);

						// Create a new driver object with combined properties
						return {
							...driver,
							...matchingGlobalName
						};
					}
					return driver; // Return original driver if no match
				});
			}

			return riskCopy;
		});
	}

	return policyCopy;
}

async function addNarrativesToModPolicy(activeRisk, policy, changeOnPremium, PolicyNetworkLayer, dispatch) {
	let policyModResponse;
	let only_calculate_premium = false;

	const policyPrefix = policy.policy_prefix;
	const hasMortgagee = activeRisk?.mortgagees && activeRisk.mortgagees.length > 0;

	const rawRegisteredValue = activeRisk?.registered_in_name ??
		activeRisk?.vehicle_registered_in_name ??
		activeRisk?.vehicleRegisteredInName ??
		activeRisk?.registeredToInsured ??
		activeRisk?.is_vehicle_registered_in_name;

	const normalizedRegisteredValue = typeof rawRegisteredValue === 'string'
		? rawRegisteredValue.trim().toLowerCase()
		: rawRegisteredValue;

	logger.log("normalizedRegisteredValue: ", normalizedRegisteredValue);
	const isRegisteredInName = normalizedRegisteredValue === true
		|| normalizedRegisteredValue === 'yes'
		|| normalizedRegisteredValue === 'y'
		|| normalizedRegisteredValue === 'true';

	// Comprehensive policy prefixes
	const comprehensivePrefixes = ['MPCC', 'MPCCS', 'MCPC', 'MPRC', 'MUWC', 'MCOC', 'MCOCS', 'MPRCC', 'MUWCC'];
	// Third party policy prefixes
	const thirdPartyPrefixes = ['MPCTP', 'MPCTPS', 'MCOTP', 'MCOTPS', 'MCPTP'];



	const rawPurchaseLocation = activeRisk?.vehicle_purchase_location ??
		activeRisk?.purchase_location ??
		activeRisk?.vehiclePurchaseLocation ??
		activeRisk?.vehicle_purchaseLocation ??
		'';

	const purchaseLocation = typeof rawPurchaseLocation === 'string' ? rawPurchaseLocation.trim() : '';
	const purchaseLocationKey = purchaseLocation.toLowerCase();
	let narrativeAddResult;

	// narrative code
	// 2035 - Kindly Submit  Motor Vehicle Fitness And Registration Certificates At Renewal.
	// 2041 - Kindly Submit a Valuation Report
	// 2075 - Kindly submit photographs of the vehicle to include all panels and glass (including windows and sunroof).
	// 2080 - Kindly submit a copy of the Motor Vehicle Title in the name of the previous owner 
	// 2081 - Kindly submit a copy of the Proforma Invoice 
	// 2082 - Kindly submit a copy of the Motor Vehicle Import Entry 
	// 2072 - upload drivers license 

	if (comprehensivePrefixes.includes(policyPrefix)) {
		if (!isRegisteredInName) {
			if (purchaseLocationKey === 'local new car dealership') {

				narrativeAddResult = await PolicyNetworkLayer.addPolicyNarrative(policy.policy_id, ["2081", "2035"]);
				if (narrativeAddResult.success) {
					dispatch(setGlobalNarratives({
						certificateOfFitness: { description: "Certificate of Fitness", code: "2035" },
						proformaInvoiceAllPages: { description: "Proforma Invoice", code: "2081" }
					}))
				}
			} else if (purchaseLocationKey === 'pre-owned (already registered in jamaica)') {
				narrativeAddResult = await PolicyNetworkLayer.addPolicyNarrative(policy.policy_id, ["2075", "2041", "2080", "2035"]);
				if (narrativeAddResult.success) {
					dispatch(setGlobalNarratives({
						certificateOfFitness: { description: "Certificate of Fitness", code: "2035" },
						valuationReport: { description: "Valuation Report", code: "2041" },
						vehicleRegistration: { description: "Motor Vehicle Registration", code: "2035" },
						motorVehicleTitle: { description: "Motor Vehicle Title (Back and Front)", code: "2080" },
						vehiclePhotographs: { description: "Photograph of Vehicle (all sections including glass & windows)", code: "2075" }
					}))
				}
			} else if (purchaseLocationKey === 'used car dealer with vehicle not yet registered in jamaica') {
				narrativeAddResult = await PolicyNetworkLayer.addPolicyNarrative(policy.policy_id, ["2075", "2041", "2082", "2035"]);
				if (narrativeAddResult.success) {
					dispatch(setGlobalNarratives({
						certificateOfFitness: { description: "Certificate of Fitness", code: "2035" },
						valuationReport: { description: "Valuation Report", code: "2041" },
						vehicleRegistration: { description: "Motor Vehicle Registration", code: "2035" },
						vehicleImportEntryForm: { description: "Vehicle Import Entry Form", code: "2082" },
						vehiclePhotographs: { description: "Photograph of Vehicle (all sections including glass & windows)", code: "2075" }
					}))
				}
			} else {
				narrativeAddResult = await PolicyNetworkLayer.addPolicyNarrative(policy.policy_id, ["2041", "2035"]);
				if (narrativeAddResult.success) {
					dispatch(setGlobalNarratives({
						certificateOfFitness: { description: "Certificate of Fitness", code: "2035" },
						valuationReport: { description: "Valuation Report", code: "2041" },
						vehicleRegistration: { description: "Motor Vehicle Registration", code: "2035" }
					}))
				}
			}
		} else if (hasMortgagee && isRegisteredInName) {
			narrativeAddResult = await PolicyNetworkLayer.addPolicyNarrative(policy.policy_id, ["2075", "2041", "2035"]);
			if (narrativeAddResult.success) {
				dispatch(setGlobalNarratives({
					certificateOfFitness: { description: "Certificate of Fitness", code: "2035" },
					valuationReport: { description: "Valuation Report", code: "2041" },
					vehicleRegistration: { description: "Motor Vehicle Registration", code: "2035" },
					vehiclePhotographs: { description: "Photograph of Vehicle (all sections including glass & windows)", code: "2075" }
				}))
			}
		} else if (!hasMortgagee && isRegisteredInName) {
			narrativeAddResult = await PolicyNetworkLayer.addPolicyNarrative(policy.policy_id, ["2080", "2075", "2041", "2035"]);
			if (narrativeAddResult.success) {
				dispatch(setGlobalNarratives({
					certificateOfFitness: { description: "Certificate of Fitness", code: "2035" },
					valuationReport: { description: "Valuation Report", code: "2041" },
					vehicleRegistration: { description: "Motor Vehicle Registration", code: "2035" },
					motorVehicleTitle: { description: "Motor Vehicle Title (Back and Front)", code: "2080" },
					vehiclePhotographs: { description: "Photograph of Vehicle (all sections including glass & windows)", code: "2075" }
				}))
			}
		} else {
			narrativeAddResult = await PolicyNetworkLayer.addPolicyNarrative(policy.policy_id, ["2041", "2035"]);
			if (narrativeAddResult.success) {
				dispatch(setGlobalNarratives({
					certificateOfFitness: { description: "Certificate of Fitness", code: "2035" },
					valuationReport: { description: "Valuation Report", code: "2041" },
					vehicleRegistration: { description: "Motor Vehicle Registration", code: "2035" }
				}))
			}
		}
	} else if (thirdPartyPrefixes.includes(policyPrefix)) {
		if (isRegisteredInName) {
			narrativeAddResult = await PolicyNetworkLayer.addPolicyNarrative(policy.policy_id, ["2080", "2035"]);
			if (narrativeAddResult.success) {
				dispatch(setGlobalNarratives({
					certificateOfFitness: { description: "Certificate of Fitness", code: "2035" },
					motorVehicleTitle: { description: "Motor Vehicle Title (Back and Front)", code: "2080" },
					vehicleRegistration: { description: "Motor Vehicle Registration", code: "2035" }
				}))
			}
		} else {
			narrativeAddResult = await PolicyNetworkLayer.addPolicyNarrative(policy.policy_id, ["2080", "2035"]);
			if (narrativeAddResult.success) {
				dispatch(setGlobalNarratives({
					certificateOfFitness: { description: "Certificate of Fitness", code: "2035" },
					motorVehicleTitle: { description: "Motor Vehicle Title (Back and Front)", code: "2080" },
					vehicleRegistration: { description: "Motor Vehicle Registration", code: "2035" }
				}))
			}
		}


		if (narrativeAddResult.success) {
			toast.success("required documents info added to policy");
			logger.log("Missing narratives successfully added");
		} else {
			toast.success("required documents could not be added to policy");
			logger.log("required documents could not be added to policy");
		}
	}
}

async function handleRewrittenPolicyTransaction({
	PolicyHelper,
	policy,
	user,
	completedSteps,
	paymentDetails,
	_transaction,
	setLoadingMessage,
	dispatch,
	files,
	policyNumber,
	getPaymentScheduleInfo,
	addPaymentReminder,
	renewalResult,
	responseAfterUpdate,
	quote,
	paymentformData,
	PolicyNetworkLayer,
	oldPolicy,
	ClaimsNetworkLayer
}) {
	logger.log("[handleRewrittenPolicyTransaction] START");
	logger.log("Incoming renewalResult:", renewalResult);
	logger.log("Incoming transaction_id:", renewalResult?.transaction_id);
	logger.log(
		"Files at entry:",
		files.map(f => f.filename || f.file_name)
	);

	// This logs the live object — you can expand/collapse all levels in DevTools
	logger.log(_transaction);

	// Or, if you want an immediately serialized snapshot:
	logger.log(JSON.stringify(_transaction, null, 2));

	_transaction.current.transaction_id = renewalResult?.transaction_id;

	dispatch(setLoadingMessage("Generating Policy Documents"));
	try {
		const updatedPolicy = appendGlobalNamesToDrivers(oldPolicy);
		let pdfFiles = [];

		let buySummaryPDF = await handleCreateBuySummaryPDF(updatedPolicy,
			quote,
			paymentformData,
			oldPolicy.policy_number
		);

		if (buySummaryPDF?.success === false) {
			throw new Error(buySummaryPDF?.message);
		} else {
			pdfFiles.push({ file_name: policy.policy_number + " New Business Summary.pdf", data: buySummaryPDF });
		}
		const received_from = user.is_a_company ? user.company_name : user.first_name + " " + user.last_name;
		const note = "The followng was uploaded by the ";
		const currentPolicyNumber = policy.policy_number;
		const description = "Online New Business Proposal Form - Summary"
		const registryType = "Customer Information update";
		const assigned_to_id = "";


		let registryResult = await PolicyNetworkLayer.sendRegistryEmail(
			branchInfo.branch_name,
			policy,
			user,
			received_from,
			{},
			note,
			"",
			currentPolicyNumber,
			description,
			registryType,
			"Policy",
			"New Business PDF Summary",
			"Underwriting",
			assigned_to_id
		);

		if (registryResult.success) {
			pdfFiles.map(async file => {
				let uploadNewBusiness = await ClaimsNetworkLayer.linkRegistryFile(
					registryResult.registry_id,
					"New Businesss Summary PDF.pdf",
					"pdf",
					file?.data,
					"Online New Business Proposal Form - Summary",
					"File",
					() => { }
				);

			});
		}

	} catch (error) { logger.log(error) }
	const docs = await PolicyHelper.generateDocuments(policy, user, completedSteps.current.renewal, paymentDetails);
	logger.log("[handleRewrittenPolicyTransaction] docs:", docs);
	files.push(...docs);
	logger.log(
		"After docs, files:",
		files.map(f => f.filename)
	);

	//@todo add specific addExtension function for additional benefits
	if (_transaction.current.paymentType?.payment_terms?.length > 1) {
		/** generate the payment schedule for renewal */
		let _terms = _transaction.current.paymentType?.payment_terms.map(term => ({ ...term, status: "-" }));
		_terms[0].status = "Paid";

		logger.log("[handleRewrittenPolicyTransaction] terms for schedule:", _terms);

		const scheduleResult = await getPaymentScheduleInfo(
			_terms,
			user,
			// @ts-ignore
			policy
		);

		logger.log("[handleRewrittenPolicyTransaction] schedule result:", scheduleResult?.slice?.(0, 50), "...");
		files.push({
			filename: "payment-schedule.pdf",
			fileContent: scheduleResult,
			// mime_type: "application/pdf",
		});

		let nextTerm = _transaction.current.paymentType?.payment_terms.find(term => !term.transaction_id);

		// if not full payment add reminder
		addPaymentReminder({
			policynum: policyNumber,
			customer: `${user.first_name} ${user.last_name}`,
			email: `${user.email_address}`,
			phone: user.phone_numbers?.[0].phone_number,
			dueDate: nextTerm.effective_date,
			reminder_type: "paybalance",
		});
	}
	responseAfterUpdate = { ...completedSteps.current.renewal };

	const policyDocumentsResult = await getPaymentPolicyDocuments(policy, _transaction.current.transaction_id);
	const { documents } = policyDocumentsResult;

	// 1) policy booklet (always present? guard anyway)
	if (
		documents.policyBooklet?.policyDocName !== null &&
		documents.policyBooklet?.policyDocName !== undefined &&
		documents.policyBooklet.policyDocPdfBase64 !== null &&
		documents.policyBooklet.policyDocPdfBase64 !== undefined
	) {
		files.push({
			filename: documents.policyBooklet.policyDocName,
			fileContent: documents.policyBooklet.policyDocPdfBase64,
		});
	}

	// 2) litigation indemnity
	if (
		documents.litigationIndemnity?.file?.file_name !== null &&
		documents.litigationIndemnity?.file?.file_name !== undefined &&
		documents.litigationIndemnity.file.data !== null &&
		documents.litigationIndemnity.file.data !== undefined
	) {
		files.push({
			filename: documents.litigationIndemnity.file.file_name,
			fileContent: documents.litigationIndemnity.file.data,
		});
	}

	// 3) mortgagee clause
	if (
		documents.mortgageeClause !== null &&
		documents.mortgageeClause !== undefined &&
		documents.mortgageeClause?.file?.file_name !== null &&
		documents.mortgageeClause?.file?.file_name !== undefined &&
		documents.mortgageeClause.file.data !== null &&
		documents.mortgageeClause.file.data !== undefined
	) {
		files.push({
			filename: documents.mortgageeClause.file.file_name,
			fileContent: documents.mortgageeClause.file.data,
		});
	}

	logger.log(
		"After policy docs, files:",
		files.map(f => f.filename)
	);

	return renewalResult;
}
async function handleRenewalTransaction({
	user,
	policy,
	formatPolicyForRenewal,
	updateExtensions,
	PolicyHelper,
	_transaction,
	paymentDetails,
	completedSteps,
	dispatch,
	setLoadingMessage,
	addBenefits,
	cart,
	promoCodes,
	policyNumber,
	renewalResult,
	getPaymentScheduleInfo,
	addPaymentReminder,
	files,
	responseAfterUpdate,
	activeRisk,
	/* assignReceipt,
	drawReceipt,
	createLog,
	toggleReceiptErrorModalState,
	checkExpToken,
	transactionType,
	reference,
	billingDetails,
	error,
	currency,
	tmpToken,
	amount,
	toast,
	*/
}) {
	dispatch(setLoadingMessage("Renewing And Updating Policy"));

	// get existing extensions
	let _extensions = policy.extensions;
	if (_transaction.current?.extensions !== undefined) _extensions.push(...(_transaction.current?.extensions || []));

	let { _cart, _manualExtensions, _policy } = formatPolicyForRenewal({
		policy,
		cart,
		extensions: _extensions,
		promoCodes,
	});

	// Apply updated extensions for each risk before building the payload
	for (const risk of policy.risks) {
		updateExtensions(_policy, risk, addBenefits);
	}

	const updatedPolicy = PolicyHelper.removeMortgagee({ ..._policy });

	/* 1. To be removed from this file and placed in payment Form file */
	// Create receipt in underwriter
	/* let receipt = assignReceipt(policy, _transaction.current.paymentAmount, paymentDetails.premiumPA_UM);
	let successful = false;
	if (!completedSteps.current.receipt) {
		let receiptResponse;
		let count = 0;

		try {
			while (count < 2 && !receiptResponse) {
				receiptResponse = await drawReceipt( receipt);
				count++;
			}
			if (!receiptResponse || !receiptResponse?.success) {
				toggleReceiptErrorModalState.openModal();
				successful = false;
			} else {
				completedSteps.current.receipt = receiptResponse;
				successful = true;
			}
		} catch (e) {
			toggleReceiptErrorModalState.openModal();
		} finally {
			createLog({
				trn: user?.national_id,
				type: `${transactionType}-Paymentform-DrawReceipt`,
				data: {
					receiptNum: reference,
					filesGenerated: files.map(f => f.filename),
					receiptResponse,
					Count: count,
				},
				errors: { message: error || !receiptResponse?.success ? receiptResponse?.error_message : "" },
			});
			try {
				if (!successful) {
					await checkExpToken({
						endpoint: "/email/quickpay",
						payload: {
							amount: `${amount.replace(/[, ]+/g, "").trim()}`,
							receipt_number: `${reference}`,
							name: `${billingDetails.firstName} ${billingDetails.lastName}`,
							email: billingDetails.email,
							phone: billingDetails.phoneNumber,
							policy_number: policyNumber,
							type: paymentDetails.paymentPurpose,
							currency: currency,
							successful: successful,
						},
					 
					});
				}
			} catch (e) {
				toast.error(e.message);
			}
		}
	} */
	/* 1. Ends here */

	if (!completedSteps.current.renewal?.success) {
		const newCodes = _transaction.current.codes;

		const vehicleOver5MillionMarketValueLimit = 5000000;

		const currentYear = new Date().getFullYear();

		const newSumInsured = activeRisk?.sum_insured;

		const ratingCodeToRemove = 702;

		let _newRisks;
		let newlyUpdatedPolicy = {};
		if (newSumInsured < vehicleOver5MillionMarketValueLimit || currentYear - activeRisk?.year > 5) {
			const risks = policy.risks.length > 1 ? policy.risks : [...[activeRisk]];

			_newRisks = removeRatingCodesFromRisks(risks, [ratingCodeToRemove]);

			if (_newRisks[0]?.rates)
				_newRisks[0] = [
					{ ..._newRisks[0], rates: _newRisks[0]?.rates.filter(rate => rate.code !== ratingCodeToRemove) },
				];

			newlyUpdatedPolicy = { ...updatedPolicy, risks: _newRisks.flat() };
		} else {
			newlyUpdatedPolicy = updatedPolicy;
		}

		renewalResult = await PolicyHelper.renewAndUpdatePolicy(
			newlyUpdatedPolicy,
			user,
			newCodes,
			{
				total: _transaction.current.paymentAmount,
				paymentPlan: _transaction.current.paymentType,
				extensions: _transaction.current.extensions,
				premiumPA_UM: _transaction.current.premiumPA_UM,
			},
			completedSteps
		);

		completedSteps.current.renewal = renewalResult;
		if (!renewalResult?.success) throw new Error(`Failed to renew policy. ${renewalResult?.error_message}`);
	}

	dispatch(setLoadingMessage("Generating Policy Documents"));
	files.push(
		...(await PolicyHelper.generateDocuments(updatedPolicy, user, completedSteps.current.renewal, paymentDetails))
	);

	//@todo add specific addExtension function for additional benefits
	if (_transaction.current.paymentType?.payment_terms?.length > 1) {
		/** generate the payment schedule for renewal */
		let _terms = _transaction.current.paymentType?.payment_terms.map(term => ({ ...term, status: "-" }));
		_terms[0].status = "Paid";

		const scheduleResult = await getPaymentScheduleInfo(
			_terms,
			user,
			// @ts-ignore
			policy
		);
		files.push({
			filename: "payment-schedule.pdf",
			fileContent: scheduleResult,
			// mime_type: "application/pdf",
		});

		let nextTerm = _transaction.current.paymentType?.payment_terms.find(term => !term.transaction_id);

		// if not full payment add reminder
		addPaymentReminder({
			policynum: policyNumber,
			customer: `${user.first_name} ${user.last_name}`,
			email: `${user.email_address}`,
			phone: user.phone_numbers?.[0].phone_number,
			dueDate: nextTerm.effective_date,
			reminder_type: "paybalance",
		});
	}
	responseAfterUpdate = { ...completedSteps.current.renewal };

	return renewalResult;
}

async function handlePayBalanceTransaction({
	dispatch,
	setLoadingMessage,
	completedSteps,
	policy,
	user,
	policyNumber,

	getPaymentScheduleInfo,
	_transaction,
	generateExtensionDocuments,
	extendPolicy,
	paymentScheduleData,
	isFuture,
	addPaymentReminder,
	removePaymentReminder,

	files,
	responseAfterUpdate,
	/* assignReceipt,
	paymentDetails,
	drawReceipt,
	toggleReceiptErrorModalState,
	createLog,
	transactionType,
	reference,
	error,
	amount,
	billingDetails,
	currency,
	tmpToken,
	checkExpToken,
	toast,
	 */
}) {
	dispatch(setLoadingMessage("Extending Cover"));
	/*    let successful = false;
	   if (!completedSteps.current.receipt || completedSteps.current.receipt.success === false) {
		   let receipt = assignReceipt(policy, paymentDetails.paymentAmount);
		   /** Generate receipt in underWriter /
   
		   let receiptResponse;
		   let count = 0;
   
		   try {
			   while (count < 2 && !receiptResponse) {
				   receiptResponse = await drawReceipt( receipt);
				   count++;
			   }
			   if (!receiptResponse || !receiptResponse?.success) {
				   toggleReceiptErrorModalState.openModal();
   
			   } else {
				   completedSteps.current.receipt = receiptResponse;
				   successful = true;
			   }
		   } catch (e) {
			   toggleReceiptErrorModalState.openModal();
		   } finally {
			   createLog({
				   trn: user?.national_id,
				   type: `${transactionType}-Paymentform-DrawReceipt`,
				   data: {
					   receiptNum: reference,
					   filesGenerated: files.map(f => f.filename),
					   receiptResponse,
					   Count: count,
				   },
				   errors: { message: error || !receiptResponse?.success ? receiptResponse?.error_message : "" },
			   });
   
			   try {
				   if (!successful) {
					   await checkExpToken({
						   endpoint: "/email/quickpay",
						   payload: {
							   amount: `${amount.replace(/[, ]+/g, "").trim()}`,
							   receipt_number: `${reference}`,
							   name: `${billingDetails.firstName} ${billingDetails.lastName}`,
							   email: billingDetails.email,
							   phone: billingDetails.phoneNumber,
							   policy_number: policyNumber,
							   type: paymentDetails.paymentPurpose,
							   currency: currency,
							   successful: successful,
						   },
					    
					   });
				   }
			   } catch (e) {
				   toast.error(e.message);
			   }
		   }
	   } */

	if (!completedSteps.current.paymentSchedule || completedSteps.current.paymentSchedule.success === false) {
		const scheduleResult = await getPaymentScheduleInfo(
			_transaction.current.paymentType?.payment_terms,
			user,
			// @ts-ignore
			policy
		);
		if (!scheduleResult) {
			throw new Error(`Failed to generate Payment Schedule. ${scheduleResult?.message}`);
		}
		completedSteps.current.paymentSchedule = scheduleResult;
	}

	/** loop through extensions */
	for (let a = 0; a < _transaction.current.totalPayments; a++) {
		if (!completedSteps.current.extension?.[a] || completedSteps.current.extension?.[a]?.success === false) {
			let extensionResponse = await extendPolicy(
				policy,
				policy.paymentPlan,
				_transaction.current.paymentType?.payment_terms?.[1]?.payment_term_premium,
				user.national_id
			);

			completedSteps.current.extension[a] = extensionResponse;
			if (!extensionResponse?.success) throw new Error(`Could not extend policy. ${extensionResponse?.error_message}`);

			/** get documents */
			//logger.warn( policy.policy_id, user.national_id, extensionResponse);
		}
		dispatch(setLoadingMessage("Generating Policy Documents"));
		files.push(
			...(await generateExtensionDocuments(
				policy,
				user.national_id,
				completedSteps.current.extension[a]?.transaction_id || ""
			))
		);
	}

	files.push({
		filename: "payment-schedule.pdf",
		fileContent: completedSteps.current.paymentSchedule,
		// mime_type: "application/pdf",
	});

	// set a payment reminder
	let nextTerm = paymentScheduleData.filter(terms => {
		let due = new Date(terms.date);
		let isFutureDate = isFuture(due);
		return terms.status !== "Paid" && isFutureDate;
	});

	//check if reminder exist and remove it
	removePaymentReminder({
		policy_number: policyNumber,
		reminder_type: "paybalance",
	});

	if (nextTerm.length > 0) {
		addPaymentReminder({
			policynum: policyNumber,
			customer: user.first_name || user.last_name ? `${user.first_name} ${user.last_name}` : user.company_name,
			email: `${user.email_address}`,
			phone: user.phone_numbers[0].phone_number,
			dueDate: nextTerm[0].date,
			reminder_type: "paybalance",
		});
	}
	responseAfterUpdate = {};

	return completedSteps.current.extension;
}

async function handleAdditionalPremiumTransaction({
	policyFormInfo,
	activeRisk,
	changeMarketValue,

	policy,
	changeOnPremium,
	gct,

	policyPaymentPlans,
	setError,
	openErrorModal2,
	user,
	PolicyNetworkLayer,
	completedSteps,
	/*    assignReceipt,
	   paymentDetails,

	   drawReceipt,
	   toggleReceiptErrorModalState,
	   createLog,
	   transactionType,
	   reference,
	   error,
	   checkExpToken,
	   amount,
	   billingDetails,
	   policyNumber,
	   currency,
	   tmpToken, */
	dispatch,
	setLoadingMessage,
	toast,
	filesNeeded,
	FILESNEEDED,
	formatMoney,
	newPremium,
	policyManagerData,
	isNotEmpty,
	nodeApi,
	files,
}) {

	const newSumInsured = policyFormInfo.newMarketValues.find(
		marketValue => marketValue?.riskID?.trim() === activeRisk?.risk_id
	)?.marketValue;
	const registrationEntry = policyFormInfo?.newRegistrationNumbers?.find(
		entry => entry?.riskID?.trim() === activeRisk?.risk_id
	);
	const registrationUpdate = registrationEntry?.registrationNumber
		? { risk_id: activeRisk?.risk_id, registration_number: registrationEntry.registrationNumber }
		: null;
	let marketValueResult;
	let only_calculate_premium = false;
	try {
		const vehicleOver5MillionMarketValueLimit = 5000000;

		let _newRisks = [];
		let _policy = policy;

		const ratingCodeToRemove = 702;

		const currentYear = new Date().getFullYear();

		if (newSumInsured < vehicleOver5MillionMarketValueLimit || currentYear - activeRisk.year > 5) {
			let risks = [...[activeRisk]];

			_newRisks = removeRatingCodesFromRisks(risks, [ratingCodeToRemove]);

			_policy = {
				...policy,
				risks: policy?.risks?.map(risk => (risk?.risk_id === _newRisks[0]?.risk_id ? _newRisks[0] : risk)),
			};
		}

		marketValueResult = await changeMarketValue(
			_policy,
			_newRisks[0] ?? activeRisk,
			newSumInsured,
			changeOnPremium,
			policyPaymentPlans,
			only_calculate_premium,
			registrationUpdate
		);

		completedSteps.current.additionalPremium = marketValueResult;
		if (marketValueResult?.error_message) throw marketValueResult?.error_message;
	} catch (error) {
		setError(error);
		openErrorModal2(true);
	}

	let vehiclesInfo = [];
	let userName = user.is_a_company ? user.company_name : user?.first_name + " " + user?.last_name;
	let customerInfo = {
		name: userName,
		first_name: user.is_a_company ? user.company_name : user?.first_name,
		last_name: user.is_a_company ? "" : user?.last_name,
		phoneNumber: { wasChanged: false, value: "" },
		otherPhoneNumber: {
			wasChanged: false,
			value: "",
		},
		email: { wasChanged: false, value: user.email_address },
		homeAddress: { wasChanged: false, value: "" },
	};

	let transScheduleResponse = await PolicyNetworkLayer.getTransactionSchedule(marketValueResult.transaction_id);
	files.push({ ...transScheduleResponse.data, type: "Transaction Schedule" });
	let driversInfo = [];
	/*    let receipt = assignReceipt(policy, paymentDetails.paymentAmount);
	   let successful = false;
   
	   if (!completedSteps.current.receipt || completedSteps.current.receipt.success === false) {
		   /** Generate receipt in underWriter /
		   let receiptResponse;
		   let count = 0;
		   try {
			   while (count < 2 && !receiptResponse) {
				   receiptResponse = await drawReceipt( receipt);
				   count++;
			   }
			   if (!receiptResponse || !receiptResponse?.success) {
				   toggleReceiptErrorModalState.openModal();
				   successful = false;
			   } else {
				   completedSteps.current.receipt = receiptResponse;
				   successful = true;
			   }
		   } catch (e) {
			   toggleReceiptErrorModalState.openModal();
		   } finally {
			   createLog({
				   trn: user?.national_id,
				   type: `${transactionType}-Paymentform-DrawReceipt`,
				   data: {
					   receiptNum: reference,
					   filesGenerated: files.map(f => f.filename),
					   receiptResponse,
					   Count: count,
				   },
				   errors: { message: error || !receiptResponse?.success ? receiptResponse?.error_message : "" },
			   });
   
			   try {
				   await checkExpToken({
					   endpoint: "/email/quickpay",
					   payload: {
						   amount: `${amount.replace(/[, ]+/g, "").trim()}`,
						   receipt_number: `${reference}`,
						   name: `${billingDetails.firstName} ${billingDetails.lastName}`,
						   email: billingDetails.email,
						   phone: billingDetails.phoneNumber,
						   policy_number: policyNumber,
						   type: paymentDetails.paymentPurpose,
						   currency: currency,
						   successful: successful,
					   },
					   
				   });
			   } catch (e) {
				   toast.error(e.message);
			   }
		   }
	   } */

	let selectedRisk = policy.risks.find(risk => risk.risk_id === policyFormInfo.newMarketValues[0].riskID);
	if (changeOnPremium >= 0) {
		// create certificate
		dispatch(setLoadingMessage("Creating Certificate"));
		let certResponse = await PolicyNetworkLayer.createCertificate(policy?.policy_id, selectedRisk.risk_id);
		let file;
		if (certResponse?.success) {
			// get/save certificate data
			file = certResponse.data;
		} else {
			toast.error(`Create Certificate failed ${certResponse.error_message}`);
		}

		files.push({ ...file, type: "Certificate of Insurance" });
		if (policyFormInfo?.newMarketValues[0]?.files?.length === 0) {
			filesNeeded.push(FILESNEEDED.Valuation);
		}
	}

	let vehicleInfo = {
		make: selectedRisk.make,
		model: selectedRisk.model,
		year: selectedRisk.year,
		registrationNumber: {
			wasChanged: false,
			value: selectedRisk.registration_number || "",
		},
		marketValue: {
			wasChanged: true,
			value: formatMoney(policyFormInfo.newMarketValues[0].marketValue).toString(),
		},
		premium: { wasChanged: true, value: formatMoney(newPremium).toString() },
		files: files,
		filesNeeded: filesNeeded,
		policy_number: policy?.policy_number,
		payment_amount: formatMoney(changeOnPremium + (gct || 0)),
	};

	vehiclesInfo.push(vehicleInfo);

	policyManagerData = {
		fullname: user.is_a_company ? `${user.company_name}` : `${user.first_name} ${user.last_name}`,
		email: isNotEmpty(policyFormInfo?.newEmail?.trim()) ? policyFormInfo?.newEmail?.trim() : user.email_address,
		registrationNumbers: [],
		certificates: files,
	};

	let emailResult;
	try {
		// Timeout wrapper: Race with a 15s reject
		const timeoutPromise = new Promise((_, reject) =>
			setTimeout(() => reject(new Error('Email timeout')), 15000)
		);

		// 1. Policy Update Email (documents without receipt)
		emailResult = await Promise.race([checkExpToken({
			endpoint: "/email/policyManager",
			payload: {
				customerInfo,
				vehiclesInfo,
				driversInfo,
				variant: "postUploadDocs"
			},
		}), timeoutPromise
		]);

		if (emailResult.success) {
			dispatch(setLoadingMessage("Sending email"));
			toast.success("An email has been sent with an outline of all your changes.");
		} else {
			logger.warn("Email send failed:", emailResult?.error_message);
		}
	} catch (emailError) {
		logger.error("Email send error:", emailError.message);
	}

	if (policyFormInfo?.newMarketValues[0]?.files?.length === 0) {
		await checkExpToken({
			endpoint: "/email/policyManagerReminder",
			payload: {
				customerInfo,
				vehiclesInfo,
			},
		});
	}

	if (marketValueResult && typeof marketValueResult === "object" && !Array.isArray(marketValueResult)) {
		marketValueResult.emailPayload = { customerInfo, vehiclesInfo, driversInfo };
	}

	return marketValueResult;
}



async function handleAdditionalVehicleTransaction({
	policyFormInfo,
	activeRisk,
	policy,
	policyPaymentPlans,
	setError,
	openErrorModal2,
	user,
	PolicyNetworkLayer,
	completedSteps,
	dispatch,
	setLoadingMessage,
	toast,
	filesNeeded,
	FILESNEEDED,
	formatMoney,
	newPremium,
	policyManagerData,
	isNotEmpty,
	nodeApi,
	files,
	changeOnPremium,
	gct,
}) {
	let policyModResponse;
	let only_calculate_premium = false;
	try {
		const currentDate = new Date();
		const effectiveDate = `${(currentDate.getMonth() + 1).toString().padStart(2, "0")}/${currentDate
			.getDate()
			.toString()
			.padStart(2, "0")}/${currentDate.getFullYear()} ${currentDate
				.getHours()
				.toString()
				.padStart(2, "0")}:${currentDate.getMinutes().toString().padStart(2, "0")}:${currentDate
					.getSeconds()
					.toString()
					.padStart(2, "0")}`;
		let globalnames = policy.global_names.filter(item => item.service_type !== "Mortgagee");
		// let globalnames = '';
		policyModResponse = await PolicyNetworkLayer.addRiskToPolicy(
			policy.policy_id,
			effectiveDate,
			activeRisk,
			globalnames || [],
			"Adding vehicle(s) - CORE-U.",
			changeOnPremium,
			only_calculate_premium
		);

		completedSteps.current.additionalPremium = policyModResponse;
		if (policyModResponse?.error_message) throw policyModResponse?.error_message;
	} catch (error) {
		setError(error);
		openErrorModal2(true);
	}

	await addNarrativesToModPolicy(activeRisk, policy, changeOnPremium, PolicyNetworkLayer, dispatch);

	const registrationNumber = activeRisk.registration_number || activeRisk.registrationNumber || "";
	const chassisNumber = activeRisk.chassis_number || activeRisk.chassisNumber || "";
	const marketValue =
		policyFormInfo?.newMarketValues?.[0]?.marketValue ?? activeRisk.sum_insured ?? activeRisk?.vehicle_value ?? 0;

	// const marketValue = 50000000;

	let vehiclesInfo = [];
	let userName = user.is_a_company ? user.company_name : user?.first_name + " " + user?.last_name;
	let customerInfo = {
		name: userName,
		first_name: user.is_a_company ? user.company_name : user?.first_name,
		last_name: user.is_a_company ? "" : user?.last_name,
		phoneNumber: { wasChanged: false, value: "" },
		otherPhoneNumber: {
			wasChanged: false,
			value: "",
		},
		email: { wasChanged: false, value: user.email_address },
		homeAddress: { wasChanged: false, value: "" },
	};

	let transScheduleResponse = await PolicyNetworkLayer.getTransactionSchedule(policyModResponse?.transaction_id);
	files.push({ ...transScheduleResponse.data, type: "Transaction Schedule" });
	let driversInfo = [];


	if (policyFormInfo?.newMarketValues[0]?.files?.length === 0) {
		filesNeeded.push(FILESNEEDED.Valuation);
	}

	let vehicleInfo = {
		make: activeRisk.make,
		model: activeRisk.model,
		year: activeRisk.year,
		changeType: "addition",
		registrationNumber: {
			wasChanged: true,
			value: registrationNumber,
		},
		chassisNumber,
		chassisNum: chassisNumber,
		marketValue: {
			wasChanged: true,
			value: formatMoney(marketValue).toString(),
		},
		premium: { wasChanged: true, value: formatMoney(newPremium).toString() },
		files: files,
		filesNeeded: filesNeeded,
		policy_number: policy?.policy_number,
		payment_amount: formatMoney(changeOnPremium + (gct || 0)),
	};

	vehiclesInfo.push(vehicleInfo);

	dispatch(setActiveRisk({ ...activeRisk, risk_id: policyModResponse.risk_id }));

	policyManagerData = {
		fullname: user.is_a_company ? `${user.company_name}` : `${user.first_name} ${user.last_name}`,
		email: isNotEmpty(policyFormInfo?.newEmail?.trim()) ? policyFormInfo?.newEmail?.trim() : user.email_address,
		registrationNumbers: [],
		certificates: files,
	};

	if (policyFormInfo?.newMarketValues[0]?.files?.length === 0) {
		let res = await checkExpToken({
			endpoint: "/email/policyManagerReminder",
			payload: {
				customerInfo,
				vehiclesInfo,
			},
		});

		logger.log("Response Check:", res);
	}

	if (policyModResponse && typeof policyModResponse === "object" && !Array.isArray(policyModResponse)) {
		policyModResponse.emailPayload = { customerInfo, vehiclesInfo, driversInfo };
	}

	return policyModResponse;
}
async function handleDeletingVehicleTransaction({
	policyFormInfo,
	activeRisk,
	policy,
	policyPaymentPlans,
	setError,
	openErrorModal2,
	user,
	PolicyNetworkLayer,
	completedSteps,
	dispatch,
	setLoadingMessage,
	toast,
	filesNeeded,
	FILESNEEDED,
	formatMoney,
	newPremium,
	policyManagerData,
	isNotEmpty,
	nodeApi,
	files,
	changeOnPremium,
}) {
	let policyModResponse;
	let only_calculate_premium = false;
	const serviceFeeValue = 2500;
	const serviceFeeType = "Policy Changes";
	const transaction_premium = changeOnPremium ?? 0;
	try {
		const currentDate = new Date();
		const effectiveDate = `${(currentDate.getMonth() + 1).toString().padStart(2, "0")}/${currentDate
			.getDate()
			.toString()
			.padStart(2, "0")}/${currentDate.getFullYear()} ${currentDate
				.getHours()
				.toString()
				.padStart(2, "0")}:${currentDate.getMinutes().toString().padStart(2, "0")}:${currentDate
					.getSeconds()
					.toString()
					.padStart(2, "0")}`;

		policyModResponse = await PolicyNetworkLayer.deleteRiskFromPolicy(
			policy.policy_id,
			effectiveDate,
			activeRisk,
			policy.global_names || [],
			"Deleting a vehicle - CORE- U.",
			serviceFeeValue,
			serviceFeeType,
			only_calculate_premium,
			policy,
			transaction_premium
		);

		completedSteps.current.additionalPremium = policyModResponse;
		if (policyModResponse?.error_message) throw policyModResponse?.error_message;
	} catch (error) {
		setError(error);
		openErrorModal2(true);
	}

	logger.log("new premium: ", newPremium);
	const registrationNumber = activeRisk.registration_number || activeRisk.registrationNumber || "";
	const chassisNumber = activeRisk.chassis_number || activeRisk.chassisNumber || "";
	const marketValue = activeRisk.sum_insured ?? policyFormInfo?.newMarketValues?.[0]?.marketValue ?? 0;

	let vehiclesInfo = [];
	let userName = user.is_a_company ? user.company_name : user?.first_name + " " + user?.last_name;
	let customerInfo = {
		name: userName,
		first_name: user.is_a_company ? user.company_name : user?.first_name,
		last_name: user.is_a_company ? "" : user?.last_name,
		phoneNumber: { wasChanged: false, value: "" },
		otherPhoneNumber: {
			wasChanged: false,
			value: "",
		},
		email: { wasChanged: false, value: user.email_address },
		homeAddress: { wasChanged: false, value: "" },
	};
	let transScheduleResponse = await PolicyNetworkLayer.getTransactionSchedule(policyModResponse?.transaction_id);
	files.push({ ...transScheduleResponse.data, type: "Transaction Schedule" });
	let driversInfo = [];
	let vehicleInfo = {
		make: activeRisk.make,
		model: activeRisk.model,
		year: activeRisk.year,
		changeType: "deletion",
		registrationNumber: {
			wasChanged: false,
			value: registrationNumber,
		},
		chassisNumber,
		chassisNum: chassisNumber,
		marketValue: {
			wasChanged: false,
			value: formatMoney(marketValue).toString(),
		},
		premium: { wasChanged: true, value: formatMoney(newPremium).toString() },
		files: files,
		filesNeeded: filesNeeded,
		policy_number: policy?.policy_number,
	};

	vehiclesInfo.push(vehicleInfo);

	policyManagerData = {
		fullname: user.is_a_company ? `${user.company_name}` : `${user.first_name} ${user.last_name}`,
		email: isNotEmpty(policyFormInfo?.newEmail?.trim()) ? policyFormInfo?.newEmail?.trim() : user.email_address,
		registrationNumbers: [],
		isDeleteVehicle: true,
		certificates: files,
	};

	let emailResult;
	try {
		// Timeout wrapper: Race with a 15s reject
		const timeoutPromise = new Promise((_, reject) =>
			setTimeout(() => reject(new Error('Email timeout')), 15000)
		);

		emailResult = await Promise.race([checkExpToken({
			endpoint: "/email/policyManager",
			payload: {
				customerInfo,
				vehiclesInfo,
				driversInfo,
				variant: "receiptOnly",
			},
		}), timeoutPromise
		]);

		if (emailResult.success) {
			dispatch(setLoadingMessage("Sending email"));
			toast.success("An email has been sent with an outline of all your changes.");
		} else {
			logger.warn("Email send failed:", emailResult?.error_message);
		}
	} catch (emailError) {
		logger.error("Email send error:", emailError.message);
	}

	return policyModResponse;
}
async function handleChangeVehicleTransaction({
	policyFormInfo,
	activeRisk,
	policy,
	oldRisk,
	policyPaymentPlans,
	setError,
	openErrorModal2,
	user,
	PolicyNetworkLayer,
	completedSteps,
	dispatch,
	setLoadingMessage,
	toast,
	filesNeeded,
	FILESNEEDED,
	formatMoney,
	newPremium,
	policyManagerData,
	isNotEmpty,
	nodeApi,
	files,
	changeOnPremium,
	gct,
	transactionPremium = 0,
}) {
	let policyModResponse;
	let only_calculate_premium = false;
	const oldRiskRef = oldRisk || policy.risks.find(risk => risk.risk_id === oldRisk?.risk_id) || policy.risks.find(risk => risk.risk_id === activeRisk?.risk_id) || policy.risks[0];


	try {
		const currentDate = new Date();
		const effectiveDate = `${(currentDate.getMonth() + 1).toString().padStart(2, '0')}/${currentDate.getDate().toString().padStart(2, '0')}/${currentDate.getFullYear()} ${currentDate.getHours().toString().padStart(2, '0')}:${currentDate.getMinutes().toString().padStart(2, '0')}:${currentDate.getSeconds().toString().padStart(2, '0')}`;
		let globalnames = policy.global_names.filter(item => item.service_type !== "Mortgagee");

		let _policy = { ...policy };
		let _risks = [..._policy.risks];

	//update sum_insured for risk
	_risks = _risks.map(_risk => {
		let tempRisk = { ..._risk };
		if (_risk.risk_id === oldRiskRef?.risk_id) {
			tempRisk.sum_insured = activeRisk.sum_insured;
		}
		return tempRisk;
	});
	//update policy with updated risks
	_policy = {
		..._policy,
		risks: _risks,
	};

		let batch_actions = [];


		let riskForEtensonsAndRiders = { ...activeRisk, manual_rates: oldRisk?.manual_rates,risk_id: oldRisk?.risk_id };
						//update risk extensions and riders
						_policy = await updateExtensions(_policy, riskForEtensonsAndRiders);let _batch_actions = await updateBatchActions(_policy, policy, batch_actions);

		if (_batch_actions.length > 0) {
			const batchResponse = await PolicyNetworkLayer.batchPolicyModification({
				policy: _policy,
				startDate: effectiveDate,
				endDate: policy.end_date,
				trans_wording: "Uninsured motorist Endorsement",
				batch_actions: _batch_actions,
				only_calculate_premium: only_calculate_premium,
				transaction_premium: 0,
				is_do_not_prorate: true,
			});

			if (!batchResponse || batchResponse.success === false) {
				policyModResponse = batchResponse;
			} else {
				const vehicleChangeResponse = await PolicyNetworkLayer.changeRiskOnPolicy(
					policy.policy_id,
					effectiveDate,
					activeRisk,
					globalnames || [],
					"Adding vehicle(s) - CORE-U.",
					transactionPremium,
					only_calculate_premium,
					oldRiskRef?.risk_id || null,
					policy
				);

				if (!vehicleChangeResponse || vehicleChangeResponse.success === false) {
					policyModResponse = vehicleChangeResponse;
				} else {
					policyModResponse = {
						...vehicleChangeResponse,
						gross_premium: (vehicleChangeResponse.gross_premium || 0) + (batchResponse.gross_premium || 0),
						total_amount_due:
							(vehicleChangeResponse.total_amount_due || 0) + (batchResponse.total_amount_due || 0),
						tax_amount: (vehicleChangeResponse.tax_amount || 0) + (batchResponse.tax_amount || 0),
						service_charge: (vehicleChangeResponse.service_charge || 0) + (batchResponse.service_charge || 0),
						transaction_id: vehicleChangeResponse.transaction_id, // Use the vehicle change transaction id
					};
				}
			}
		} else {
			policyModResponse = await PolicyNetworkLayer.changeRiskOnPolicy(
				policy.policy_id,
				effectiveDate,
				activeRisk,
				globalnames || [],
				"Adding vehicle(s) - CORE-U.",
				only_calculate_premium,
				oldRiskRef?.risk_id || null,
				policy
			);
		}

		completedSteps.current.additionalPremium = policyModResponse;
		if (policyModResponse?.error_message) throw policyModResponse?.error_message;

	} catch (error) {
		setError(error);
		openErrorModal2(true);
	}

	await addNarrativesToModPolicy(activeRisk, policy, changeOnPremium, PolicyNetworkLayer, dispatch);

	let vehiclesInfo = [];
	let userName = user.is_a_company ? user.company_name : user?.first_name + " " + user?.last_name;
	let customerInfo = {
		name: userName,
		first_name: user.is_a_company ? user.company_name : user?.first_name,
		last_name: user.is_a_company ? "" : user?.last_name,
		phoneNumber: { wasChanged: false, value: "" },
		otherPhoneNumber: {
			wasChanged: false,
			value: "",
		},
		email: { wasChanged: false, value: user.email_address },
		homeAddress: { wasChanged: false, value: "" },
	};

	let transScheduleResponse = await PolicyNetworkLayer.getTransactionSchedule(policyModResponse?.transaction_id);
	files.push({ ...transScheduleResponse.data, type: "Transaction Schedule" });
	let driversInfo = [];

	let fetchNewRisk = await PolicyNetworkLayer.getPolicyRisks(policy.policy_id, false);
	let risk_id = fetchNewRisk?.risks[0]?.risk_id;

	dispatch(setActiveRisk({ ...activeRisk, risk_id: risk_id }));

	if (policyFormInfo?.newMarketValues[0]?.files?.length === 0) {
		filesNeeded.push(FILESNEEDED.Valuation);
	}

	logger.log("Old risk: ", oldRiskRef, " activeRisk: ", activeRisk);
	logger.log("new premium: ", newPremium);
	const registrationNumber = activeRisk.registration_number || activeRisk.registrationNumber || "";
	const chassisNumber = activeRisk.chassis_number || activeRisk.chassisNumber || "";
	const marketValue =
		policyFormInfo?.newMarketValues?.[0]?.marketValue ?? activeRisk.sum_insured ?? activeRisk?.vehicle_value ?? 0;

	let vehicleInfo = {
		make: activeRisk.make,
		model: activeRisk.model,
		year: activeRisk.year,
		changeType: "change",
		previousVehicle: oldRiskRef
			? {
				make: oldRiskRef.make,
				model: oldRiskRef.model,
				year: oldRiskRef.year,
				registrationNumber: oldRiskRef.registration_number || oldRiskRef.registrationNumber || "",
				chassisNumber: oldRiskRef.chassis_number || oldRiskRef.chassisNumber || "",
				marketValue: formatMoney(oldRiskRef.sum_insured || 0).toString(),
				premium: formatMoney(oldRiskRef.renewal_premium || 0).toString(),
			}
			: null,
		registrationNumber: {
			wasChanged: true,
			value: registrationNumber,
		},
		chassisNumber,
		chassisNum: chassisNumber,
		marketValue: {
			wasChanged: true,
			value: formatMoney(marketValue).toString(),
		},
		premium: { wasChanged: true, value: formatMoney(newPremium).toString() },
		files: files,
		filesNeeded: filesNeeded,
		policy_number: policy?.policy_number,
		payment_amount: formatMoney(changeOnPremium + (gct || 0)),
	};

	vehiclesInfo.push(vehicleInfo);

	policyManagerData = {
		fullname: user.is_a_company ? `${user.company_name}` : `${user.first_name} ${user.last_name}`,
		email: isNotEmpty(policyFormInfo?.newEmail?.trim()) ? policyFormInfo?.newEmail?.trim() : user.email_address,
		registrationNumbers: [],
		certificates: files,
	};

	if (policyFormInfo?.newMarketValues[0]?.files?.length === 0) {
		await checkExpToken({
			endpoint: "/email/policyManagerReminder",
			payload: {
				customerInfo,
				vehiclesInfo,
			},
		});
	}

	if (policyModResponse && typeof policyModResponse === "object" && !Array.isArray(policyModResponse)) {
		policyModResponse.emailPayload = { customerInfo, vehiclesInfo, driversInfo };
	}

	return policyModResponse;
}
export {
	handleRenewalTransaction,
	handlePayBalanceTransaction,
	handleAdditionalPremiumTransaction,
	handleRewrittenPolicyTransaction,
	handleAdditionalVehicleTransaction,
	handleChangeVehicleTransaction,
	handleDeletingVehicleTransaction,
};
